import { type DefaultContext, gqlPromise } from '@egw/clients'
import type {
  InvestmentTransferValidationInput,
  InvestmentTransferValidationOutput,
} from '../../../models/transactions/transactions'

/**
 * Get Investment Transfer Validation
 * @param investmentTransferValidationInput - InvestmentTransferValidationInput
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<InvestmentTransferValidationOutput>
 */
export const getInvestmentTransferValidation = async (
  investmentTransferValidationInput: InvestmentTransferValidationInput,
  context?: DefaultContext,
): Promise<InvestmentTransferValidationOutput> => {
  const response = (await gqlPromise(
    {
      name: 'investmentTransferValidation',
      query: `query investmentTransferValidation($investmentTransferValidationInput: InvestmentTransferValidationInput!) {
                investmentTransferValidation(investmentTransferValidationInput: $investmentTransferValidationInput) {
                ... on InvestmentTransferValidation {
                    __typename
                    _
                }
                ... on InvestmentTransferValidationError {
                    __typename
                    errorType
                }
                }
            }`,
    },
    { investmentTransferValidationInput },
    context,
  )) as { investmentTransferValidation: InvestmentTransferValidationOutput }
  return response.investmentTransferValidation
}
